import React from "react";
import PhotoCardsLightbox from "components/PhotoCardsLightbox";

const Text = props => {

  return (
    <>
      {props.work.focus.text.map((text, i) => 
        <TextTile key={i} work={text} spaceText={props.spaceText} slug={props.work.slug} />
      )}
    </>
  )
}

const TextTile = (props) => {
  return (
    <section className="text">
      <div className="info">
        <h1>{props.work.title}</h1>
        {props.spaceText(props.work.body)}
        {props.work?.link && <a href={props.work.link} target="_blank" rel="noopener"><h3>Listen &#8594;</h3></a>}
      </div>
      {(props.work.img !== null) && (
        <PhotoCardsLightbox images={[
          {url: `img/projects/${props.slug}/${props.work.img[0]}`},
          {url: `img/projects/${props.slug}/${props.work.img[1]}`}
        ]} />
      )}
    </section>
  )
}

export default Text;